import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIClientService } from '@registration/services/api-client.service';
import { APP_CONFIG } from 'app/features/register/resources/config';

// @ts-ignore
@Injectable()
export class UserProofingService {
  newProfileInfo: any;

  constructor(
    private http: HttpClient,
    private apiClient: APIClientService,
    @Inject(APP_CONFIG) private config: any,
  ) {}

  getUser(email, reviewReferenceNumber) {
    const body = {
      email,
      reviewReferenceNumber,
    };
    return this.apiClient.doPost(this.config.getUserAPI, body);
  }

  updateUser(resp) {
    return this.apiClient.doPost(this.config.updateUserAPI, resp);
  }

  setProfileInfo(newProfileInfo) {
    this.newProfileInfo = newProfileInfo;
  }

  getProfileInfo() {
    return this.newProfileInfo;
  }

  getUserProfileFromOkta(username, password, retryDob, retrySSN) {
    const body = {
      userName: username,
      password,
      dateOfBirth: retryDob,
      last4DigitsOfSsn: retrySSN,
    };
    return this.apiClient.doPost(this.config.getUserProfileFromOkta, body);
  }
}
